export default "__VITE_ASSET__sR4AobRX__"